export default "__VITE_ASSET__Nregis0l__"